<template>
  <div>
    <el-dialog
      ref="uploadDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="600px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('uploadDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <div
              class="modal-row-box"
              style="padding-bottom:10px"
            >
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-upload
                    ref="picUpload"
                    class="upload-demo"
                    style="padding-top:5px"
                    :action="picUploadAction"
                    :data="picData"
                    :before-upload="beforeAvatarUpload"
                    :before-remove="beforeRemove"
                    :file-list="initFileList"
                    :list-type="listType"
                    :accept="fileAccept"
                    :headers="{'X-Token': getToken()}"
                    multiple
                    :with-credentials="true"
                    :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                    :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
                  >
                    <el-button
                      size="small"
                      type="primary"
                    >
                      点击上传
                    </el-button>
                    <div
                      slot="tip"
                      class="el-upload__tip"
                    >
                      文件不超过20mb
                    </div>
                  </el-upload>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
import { getToken } from "@/utils/auth"
// 数据请求
import { deleteFileApi, saveOrUpdateAttachmentInfoApi, findAttachmentInfoByConditionApi } from '@/api/common'
export default {
  components: { },
  mixins: [ dialogDragMixin, setNumberMixin ],
  props: {
    dialogTitle: {
      type: String,
      default: '操作附件信息'
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    directory: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: '0'
    },
    allowRemove: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text'
    },
    fileAccept: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogAddEditForm: {
      },
      dialogAddEditFormRules: {
      },
      provinceOptions: [],
      cityOptions: [],
      picData: { directory: this.directory },
      picUploadAction: '',  
      initFileList:[],
      picList: [], // 附件对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
        this.provinceOptions = []
        this.cityOptions = []
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []
        this.dialogAddEditForm = {
          sourceType: this.sourceType,
          sourceId: this.dataId,
          attachmentName: '',
          attachmentUrl: ''
        }
        this.initData()
      }
    }
  },
  methods: {
    getToken,
    // 加载数据
    initData () {
       findAttachmentInfoByConditionApi({sourceId: this.dataId, sourceType: this.sourceType}).then(res => {
        const { data } = res
        if(data && data.length > 0){
          data.forEach(item => {
            let obj = {}
            obj.name = item.attachmentName
            obj.url = this.baseUrl + item.attachmentUrl
            obj.attachmentName = item.attachmentName
            obj.attachmentUrl = item.attachmentUrl
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
        this.loading = false
      })
    },
    //上传前
    beforeAvatarUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过20MB!')
        return false
      }
      this.isUploading = true
    },
    // 上传成功
    handleSuccess (res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.dialogAddEditForm.attachmentName = res.myFileName
        this.dialogAddEditForm.attachmentUrl = res.fileName
        saveOrUpdateAttachmentInfoApi(this.dialogAddEditForm).then(res1 => {
          if (res1.mark === '200') {
            this.isUploading = false
          }
        }).catch(() => {
          this.isUploading = false
        })
      } else {
        this.$message.error(res.message)
      }
    },
    //删除前
    // eslint-disable-next-line no-unused-vars
    beforeRemove(file, fileList){
      if(!this.allowRemove){
        this.$message.error('无权限删除附件信息!')
        return false
      }
    },
    // 删除
    handlePictureCardRemove (file, fileList, dataObj) {   
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== ''){
        saveOrUpdateAttachmentInfoApi({attachmentUrl: fileUrl, isDel: '1'})
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
